import axiosService from 'services/axiosService';
import { DOMAIN } from 'constants';

export const createOrder = params => {
  return axiosService.post(`${DOMAIN}/api/v2/logistics/create_order`, params);
};


